import { render } from "./SheetComparePage.vue?vue&type=template&id=36b0c408&scoped=true"
import script from "./SheetComparePage.vue?vue&type=script&lang=js"
export * from "./SheetComparePage.vue?vue&type=script&lang=js"

import "./SheetComparePage.vue?vue&type=style&index=0&id=36b0c408&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b0c408"]])

export default __exports__